import React from "react";
import { Spinner, SpinnerSize} from "@fluentui/react";
import { ClauseSummaryGenerator } from "./Generators/ClauseSummaryGenerator";
import { ChevronRightRegular, ChevronDownRegular} from '@fluentui/react-icons';
import { fetchAllTextFromWord } from "../Utils/CommonFunctions";
import { CopilotExtractText } from "./Generators/CopilateTextExtractor";

const ClauseSummary = () => {
  const [clauseLoader, setClauseLoader] = React.useState(true);
  const [ClauseData, setClauseData] = React.useState([])
  const [expandedItems, setExpandedItems] = React.useState({});
  const [usedIcon, setUsedIcon] = React.useState({});
  const Copilot:any= JSON.parse(localStorage.getItem("Copilot")||"{}");
  const AzureAI:any= JSON.parse(localStorage.getItem("AzureAI")||"{}");
  React.useEffect(()=>{
    fetchAzureOpenAI()
  }, [])
  const fetchAzureOpenAI = async () => {
    try {
      let keyValuePairs;
      let array;
      const documentText = await fetchAllTextFromWord();
      if (Copilot?.CopilotToggle === "Yes") {
        keyValuePairs = await CopilotExtractText(documentText, "Clause Summary");
      } else if(AzureAI?.AzureOpenAIToggle){
        keyValuePairs = await ClauseSummaryGenerator();
      }
      if (!keyValuePairs) throw new Error("No data extracted from Word document.");
       try {
         const parsed = JSON.parse(keyValuePairs);
         if (parsed) {
           array = JSON.parse(keyValuePairs);
         }
       } catch (e) {
         setClauseData([]);
         setClauseLoader(false);
        //  console.log("Non result:", keyValuePairs);
       }
       const result = Object.entries(array).map(([key, value]) => {
         return { [key]: value ? value : "-" };
       });
    
      setClauseData(result);
      // console.log(ClauseData,'data here')
      setClauseLoader(false);
    } catch (error) {
      console.error('Error fetching data:', error);
      setClauseLoader(false);
      setClauseData([]);
    }
    
  }

  const insertTextIntoWord = async (text: string) => {
    // console.log(text,"text")
    await Word.run(async (context) => {
      let selection = context.document.getSelection();
      selection.delete()
      await context.sync();
      selection.insertText(text, Word.InsertLocation.replace);
      await context.sync();
    });
  };
 
const toggleValue = (Key) => {
    setExpandedItems((prev) => ({
      ...prev,
      [Key]: !prev[Key],
    }));
   setUsedIcon((prevIcons) => ({
    ...prevIcons,
    [Key]: prevIcons[Key] === ChevronDownRegular ? ChevronRightRegular : ChevronDownRegular,
   }));
  };
return (
    <div>
      {clauseLoader ? (
        <div
          style={{
            justifyContent: "center",
            alignItems: "center",
            display: "flex",
            height: "70vh",
          }}
        >
          <Spinner size={SpinnerSize.medium} label={"Please wait... "} />
        </div>
      ) : !ClauseData?.length ? (
        <div className='NoDataFound'>No data found</div>
      ) : (
        <div style={{ paddingTop: "8px" }} className="ClauseKeyValue">
          {ClauseData?.map((item) => {
            const key: any = Object.keys(item)[0];
            const value = item[key];
            const Icon = usedIcon[key] || ChevronRightRegular;
            return (
              <div key={key}>
                <div className="ClauseKey">
                  <div>
                    {/* <Icon
                      className="pagination_dev_previous_next_button"
                      iconName={usedIcon[key] || "ChevronRight"}
                      onClick={() => toggleValue(key)}
                    /> */}
                    <Icon
                      style={{ fontSize: 20,marginTop:-1 }}
                      onClick={() => toggleValue(key)}
                    />
                  </div>
                  <div style={{ marginTop: "-2px" }}>{key.replaceAll("_", " ").replaceAll("**", "")}</div>
                </div>
                {expandedItems[key] && (
                  <div
                    className="ClauseValue"
                    id={key}
                    onClick={() => insertTextIntoWord(value.replaceAll("**", ""))}
                  >
                    {value.replaceAll("**", "") ? value.replaceAll("**", "") : '-'}
                  </div>
                )}
              </div> 
            );
          })}
        </div>
      )}
    </div>
  );
};

export default ClauseSummary;